import React from 'react';
import PropTypes from 'prop-types';

class Blockquote extends React.Component {
  render() {
    return (
      <blockquote className={this.props.pullRight ? 'pull-right' : ''}>
        <p className={this.props.quoteTheme}>{this.props.quote}</p>
        <small className={this.props.sourceTheme}>
          {this.props.source}&nbsp;
          <cite className={this.props.citeTheme} title={this.props.cite}>{this.props.cite}</cite>
        </small>
      </blockquote>
    );
  }
}

Blockquote.propTypes = {
  quote: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  quoteTheme: PropTypes.string,
  source: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  sourceTheme: PropTypes.string,
  cite: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  citeTheme: PropTypes.string,
  pullRight: PropTypes.bool
};

Blockquote.defaultProps = {
  quote: '',
  quoteTheme: '',
  source: '',
  sourceTheme: '',
  cite: '',
  citeTheme: '',
  pullRight: false
};

export default Blockquote;
